<template>
  <main class="panels">
    <b-container>
      <auto-classification />
    </b-container>
  </main>
</template>

<script>
import InitApi from "../Shared/InitApi";
import AutoClassification from "./AutoClassification.vue";

export default {
  name: "ExploreFilters",
  extends: InitApi,
  components: {
    AutoClassification
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {}
};
</script>
